module.exports={
	"Form": "RolePermissionEditManifest",
	"Scope": "RolePermission-Edit",
	"Descriptors":
	{
		"RolePermissionDetails.IDRolePermission":
		{
			"Name": "ID",
			"Hash": "RolePermEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RolePermEditIdentity",
				"Group": "RolePermEditIdentity"
			}
		},
		"RolePermissionDetails.GUIDRolePermission":
		{
			"Name": "GUID",
			"Hash": "RolePermEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RolePermEditIdentity",
				"Group": "RolePermEditIdentity"
			}
		},
		"RolePermissionDetails.Hash":
		{
			"Name": "Permission Hash",
			"Hash": "RolePermEdit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "RolePermEditIdentity",
				"Group": "RolePermEditIdentity"
			}
		},
		"RolePermissionDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "RolePermEdit-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "RolePermEditConfig",
				"Group": "RolePermEditConfig"
			}
		},
		"RolePermissionDetails.Allowed":
		{
			"Name": "Allowed",
			"Hash": "RolePermEdit-Allowed",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "RolePermEditConfig",
				"Group": "RolePermEditConfig"
			}
		},
		"RolePermissionDetails.Context":
		{
			"Name": "Context",
			"Hash": "RolePermEdit-Context",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "RolePermEditConfig",
				"Group": "RolePermEditConfig"
			}
		},
		"RolePermissionDetails.IDContext":
		{
			"Name": "Context ID",
			"Hash": "RolePermEdit-IDContext",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "RolePermEditConfig",
				"Group": "RolePermEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RolePermEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RolePermEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Permission Configuration",
			"Hash": "RolePermEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Permission Configuration",
					"Hash": "RolePermEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
